module.exports = __webpack_public_path__ + "img/31.b90876af.jpg";